import { Chip } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { ICustomerRefundRequest, CustomerRefundStatus } from '../../../types/store';
import { ViewButton } from '../../Buttons/ViewButton';

const statusColorMap: Record<CustomerRefundStatus, 'warning' | 'success' | 'error' | 'info'> = {
  PENDING: 'warning',
  APPROVED: 'success',
  REJECTED: 'error',
  PROCESSING: 'info',
};

export const getCustomerRefundColumns = (
  onClickView: (row: ICustomerRefundRequest) => void,
): GridColDef[] => [
  {
    field: 'order_number',
    headerName: 'Order #',
    flex: 1,
    minWidth: 130,
  },
  {
    field: 'customer_name',
    headerName: 'Customer',
    flex: 1.2,
    minWidth: 150,
    renderCell: (params) => (
      <div>
        <div style={{ fontWeight: 500 }}>{params.row.customer_name}</div>
        <div style={{ fontSize: 11, color: '#666' }}>{params.row.customer_email}</div>
      </div>
    ),
  },
  {
    field: 'refund_amount',
    headerName: 'Amount',
    flex: 0.8,
    minWidth: 100,
    renderCell: (params) => (
      <span>
        ₱{Number(params.row.refund_amount).toLocaleString('en-PH', { minimumFractionDigits: 2 })}
      </span>
    ),
  },
  {
    field: 'payment_method',
    headerName: 'Payment',
    flex: 0.8,
    minWidth: 100,
  },
  {
    field: 'reason',
    headerName: 'Reason',
    flex: 2,
    minWidth: 200,
  },
  {
    field: 'status',
    headerName: 'Status',
    flex: 0.9,
    minWidth: 110,
    renderCell: (params) => {
      const status = params.row.status as CustomerRefundStatus;
      return (
        <Chip
          label={status}
          color={statusColorMap[status]}
          size="small"
          sx={{ fontWeight: 600, fontSize: 11 }}
        />
      );
    },
  },
  {
    field: 'created_at',
    headerName: 'Date Filed',
    flex: 1,
    minWidth: 120,
    renderCell: (params) => {
      const date = new Date(params.row.created_at);
      return (
        <span>
          {date.toLocaleDateString('en-PH', { year: 'numeric', month: 'short', day: 'numeric' })}
        </span>
      );
    },
  },
  {
    field: 'actions',
    headerName: 'Actions',
    flex: 0.6,
    minWidth: 80,
    sortable: false,
    renderCell: (params) => (
      <ViewButton onClick={() => onClickView(params.row as ICustomerRefundRequest)} />
    ),
  },
];
